'use client';

import { Laboratory } from '@medprev-web-app/api-graphql-client';

import { LaboratoryCoverageStep } from './_steps/laboratory-coverage-step.component';
import { LaboratoryExamsStep } from './_steps/laboratory-exams-step.component';
import { LaboratorySchedulesStep } from './_steps/laboratory-schedules-step.component';
import { UseLaboratoryExamSelectionReturn } from './_hooks/use-laboratory-exam-selection.hook';
import { LaboratoryExamsFlowKeys } from './laboratory-exams-flow.types';

import { PartnerExamsCoverage } from '@/app/(main)/_components/search-modal/search-modal.types';
import { ProgressiveModal } from '@/components/ui/progressive-modal/progressive-modal.component';

interface LaboratoryExamsFlowProps {
  laboratory: Laboratory;
  laboratoryName: string;
  facilityId: string;
  coverage?: PartnerExamsCoverage;
  selection: UseLaboratoryExamSelectionReturn;
  open: boolean;
  initialKey: LaboratoryExamsFlowKeys;
  onOpenChange(open: boolean): void;
}

export function LaboratoryExamsFlow({
  laboratory,
  laboratoryName,
  facilityId,
  coverage,
  selection,
  open,
  initialKey,
  onOpenChange,
}: LaboratoryExamsFlowProps) {
  const startsAtCoverage = initialKey === LaboratoryExamsFlowKeys.COVERAGE && Boolean(coverage);

  return (
    <ProgressiveModal
      className="md:max-w-[800px] h-full md:h-[calc(4/6*100vh)]"
      open={open}
      initialKey={initialKey}
      hasHeader
      contentPadding={false}
      title={`Exames em ${laboratoryName}`}
      description="Cobertura de exames, seleção de exames e horários disponíveis"
      handleClose={() => onOpenChange(false)}
      onInteractOutside={({ event }) => event.preventDefault()}
      onOpenAutoFocus={({ event }) => event.preventDefault()}
      onCloseAutoFocus={({ event }) => event.preventDefault()}
    >
      <LaboratoryCoverageStep
        key={LaboratoryExamsFlowKeys.COVERAGE}
        coverage={coverage}
      />

      <LaboratoryExamsStep
        key={LaboratoryExamsFlowKeys.EXAMS}
        facilityId={facilityId}
        laboratoryName={laboratoryName}
        selection={selection}
        canReturnToCoverage={startsAtCoverage}
      />

      <LaboratorySchedulesStep
        key={LaboratoryExamsFlowKeys.SCHEDULES}
        laboratory={laboratory}
        procedureIds={selection.selectedIds}
        total={selection.total}
      />
    </ProgressiveModal>
  );
}
